import { render, staticRenderFns } from "./EventJoinGroup.vue?vue&type=template&id=4cf352b8&"
import script from "./EventJoinGroup.vue?vue&type=script&lang=js&"
export * from "./EventJoinGroup.vue?vue&type=script&lang=js&"
import style0 from "./EventJoinGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VContainer,
  VFlex,
  VLayout,
})
